import React from "react";
import ProgressBar from "react-bootstrap/ProgressBar";

const ReviewBar = () => {
  return (
    <div className='reviewbar-content'>
      <div className='dev-detail-reviews-rating dev-detail-reviews-barfill'>
        <div className='dev-detail-rating-bars'>
          <div className='dev-detail-rating-left'>
            <p>Timing</p>
            <div className='dev-detail-rating-rate'>
              <ProgressBar variant='dark' now={100} />
              <span>5.0</span>
            </div>
          </div>
          <div className='dev-detail-rating-left'>
            <p>Communication</p>
            <div className='dev-detail-rating-rate'>
              <ProgressBar variant='dark' now={100} />
              <span>5.0</span>
            </div>
          </div>
          <div className='dev-detail-rating-left'>
            <p>Check-in</p>
            <div className='dev-detail-rating-rate'>
              <ProgressBar variant='dark' now={100} />
              <span>5.0</span>
            </div>
          </div>
        </div>
        <div className='dev-detail-rating-bars'>
          <div className='dev-detail-rating-left'>
            <p>Accuracy</p>
            <div className='dev-detail-rating-rate'>
              <ProgressBar variant='dark' now={100} />
              <span>5.0</span>
            </div>
          </div>
          <div className='dev-detail-rating-left'>
            <p>Location</p>
            <div className='dev-detail-rating-rate'>
              <ProgressBar variant='dark' now={90} />
              <span>4.9</span>
            </div>
          </div>
          <div className='dev-detail-rating-left'>
            <p>Value</p>
            <div className='dev-detail-rating-rate'>
              <ProgressBar variant='dark' now={70} />
              <span>4.7</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewBar;
